export default "<h1>Stammdaten</h1>\r\n"